import * as React from 'react';
import * as _ from 'lodash-es';
import cx from 'classnames';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TravelPolicyTableRows from './TravelPolicyTableRows';
import Loader from 'components/Loader/Loader';
import { TravelPolicyTabTypes } from 'components/UserDetails/UserDetail';

const styles = require('./styles.pcss');

type Props = {
  isLoading: boolean;
  flightPolicy: any;
  hotelPolicy: any;
  carPolicy: any;
  product: TravelPolicyTabTypes;
};

const defaultTexts = {
  na: '-',
  allBooking: 'All Bookings',
  outOfPolicy: 'Out of Policy',
};

const advanceBooking: any = {
  name: 'Notifications',
  description: 'Bookings for which managers are notified about.',
};

const hardCap: any = {
  name: 'Approvals',
  description: 'Bookings that require manager approval.',
};

const actionStatusLabelMap: Record<string, string> = {
  always: defaultTexts.allBooking,
  outOfPolicy: defaultTexts.outOfPolicy,
};

const onRenderNotificationLabel = (policy: any) => {
  const { notifications = {}, approvals = {} } = policy || {};
  const { actionStatus: notificationAction = '' } = notifications;
  const { actionStatus: approvalAction = '' } = approvals;

  return {
    notificationLabel: notificationAction
      ? actionStatusLabelMap[notificationAction]
      : defaultTexts.na,
    approvalLabel: approvalAction
      ? actionStatusLabelMap[approvalAction]
      : defaultTexts.na,
  };
};

class NotificationsAndApprovals extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const {
      isLoading,
      product,
      flightPolicy = {},
      hotelPolicy = {},
      carPolicy = {},
    } = this.props;

    let flightNotifications = defaultTexts.na,
      hotelNotifications = defaultTexts.na,
      carNotifications = defaultTexts.na,
      flightApproval = defaultTexts.na,
      hotelApproval = defaultTexts.na,
      carApproval = defaultTexts.na;

    ({ notificationLabel: flightNotifications, approvalLabel: flightApproval } =
      onRenderNotificationLabel(flightPolicy));

    ({ notificationLabel: hotelNotifications, approvalLabel: hotelApproval } =
      onRenderNotificationLabel(hotelPolicy));

    ({ notificationLabel: carNotifications, approvalLabel: carApproval } =
      onRenderNotificationLabel(carPolicy));

    return (
      <Paper
        className={isLoading ? cx(styles.paper, styles.loading) : styles.paper}
      >
        <div className={styles.policyRules}>
          <h2>Notifications and Approvals</h2>
          <div>
            <Loader visible={isLoading} />
          </div>
          <Table>
            <TableBody>
              <TravelPolicyTableRows
                key={2}
                text={advanceBooking}
                product={product}
                flight={flightNotifications}
                hotel={hotelNotifications}
                car={carNotifications}
              />
              <TravelPolicyTableRows
                key={4}
                text={hardCap}
                product={product}
                flight={flightApproval}
                hotel={hotelApproval}
                car={carApproval}
              />
            </TableBody>
          </Table>
        </div>
      </Paper>
    );
  }
}

export default NotificationsAndApprovals;
